import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

import { AbcListComponent } from '../../../common/base-components/abc-list/abc-list.component'
import { InputType } from '../../../common/enums/input-type.enum'
import { Filter } from '../../../common/interfaces/filter.interface'
import { ResourceDefinition } from '../../../common/interfaces/resource-definition.interface'
import { BreadcrumbService } from '../../../common/services/breadcrumb.service'
import { FlashMessageService } from '../../../common/services/flash-message.service'
import { ResourceService } from '../../../common/services/resource.service'
import { objectiveDefinition } from '../objective.definition'

@Component({
  selector: 'app-objective-list',
  templateUrl:
    '../../../common/base-components/abc-list/abc-list.component.html',
  styleUrls: [
    '../../../common/base-components/abc-list/abc-list.component.scss'
  ]
})
export class ObjectiveListComponent extends AbcListComponent implements OnInit {
  definition: ResourceDefinition = objectiveDefinition

  filters: Filter[] = [
    {
      label: 'Practice',
      properties: {
        value: 'departmentId'
      },
      placeholder: 'Tous',
      selectOptions: () =>
        this.componentResourceService.listSelectOptions('departments'),
      inputType: InputType.Select,
      className: 'is-12-mobile is-6-tablet is-3-widescreen p-x-0-mobile'
    },
    {
      label: 'Année',
      properties: {
        value: 'year'
      },
      placeholder: 'Toutes',
      selectOptions: () =>
        this.componentResourceService.listSelectOptions('objectives/years'),
      inputType: InputType.Select,
      className: 'is-12-mobile is-6-tablet is-3-widescreen p-x-0-mobile'
    }
  ]

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    private componentResourceService: ResourceService
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
